import React from "react";
import Select from 'react-select';

const bigList = [];
bigList.push({ value: "allPlayerTypes", label: "All Player Options" });
bigList.push({ value: "single", label: "Single Player Only" });
bigList.push({ value: "multi", label: "Multiplayer Only" });


class NumPlayers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };

    this.selectOption = this.selectOption.bind(this);
  }

  onPlayerChange(e) {
    this.props.onPlayerFilterChange(e.value);
  }

  selectOption(e) {
    this.setState({ value: e });
    this.onPlayerChange(e);
  }

  render() {

    var label;
    if (this.props.displayPlayerFilter === "allPlayerTypes") {
      label = "All Player Options";
    } else if (this.props.displayPlayerFilter === "single") {
      label = "Single Player Only";
    } else if (this.props.displayPlayerFilter === "multi") {
      label = "Multiplayer Only";
    }

    return (
      <div className="box">
        <div className="col">
          <p>Players</p>
        </div>

        <Select
          options={bigList}
          onChange={this.selectOption}
          defaultValue = {{ label: `${label}`, value: this.props.displayPlayerFilter }} />

      </div>
    );
  }
}

export default NumPlayers;
